import { SegmentLOBModel } from "../models/SegmentLOBModel";
import API, { client } from "./API";

const SegmentLOBService = {
  async getAllSegmentLOBs() {
    const response = await API().get("SegmentLOB", {
      method: "GET",
      headers: {
        "Access-Control-Allow-Origin": "*",
        "Content-Type": "application/json",
      },
    });
    return response.data;
  },
  async getSegmentsByBU(BUID: number) {
    const response = await API().get("SegmentLOB/GetSegmentsByBU/" + BUID, {
      method: "GET",
      headers: {
        "Access-Control-Allow-Origin": "*",
        "Content-Type": "application/json",
      },
    });
    return response.data;
  },
  async getParticularSegmentLOB(segmentLOB_id: number) {
    const response = await API().get("SegmentLOB");
    return response.data.filter(
      (cur_segmentLOB: SegmentLOBModel) =>
        cur_segmentLOB.segmentlobid === segmentLOB_id
    )[0];
  },
  async createSegmentLOB(data: SegmentLOBModel, id?: number) {
    try {
      const response = await client({
        method: id ? "put" : "post",
        url: id ? `SegmentLOB/${id}` : "SegmentLOB",
        data: data,
        headers: {
          "Access-Control-Allow-Origin": "*",
          "Content-Type": "application/json",
        },
      });

      return response.data;
    } catch (error) {
      console.log(error);
    }
  },
};

export default SegmentLOBService;
